var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class BenQProjector {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.displayBlank = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\r*blank=?#`, /blank=(on|off)#/i, tags);
                return match[1] ? match[1].toLowerCase() === 'on' : this.state.displayBlank.value;
            }),
            set: (blank, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\r*blank=${blank ? 'on' : 'off'}#`, /\*blank=(on|off)#/i, tags);
                return match[1] ? match[1].toLowerCase() === 'on' : this.state.displayBlank.value;
            }),
        };
        this.displayFreeze = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\r*freeze=?#`, /freeze=(on|off)#/i, tags);
                return match[1] ? match[1].toLowerCase() === 'on' : this.state.displayFreeze.value;
            }),
            set: (freeze, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\r*freeze=${freeze ? 'on' : 'off'}#`, /\*freeze=(on|off)#/i, tags);
                return match[1] ? match[1].toLowerCase() === 'on' : this.state.displayFreeze.value;
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\r*pow=?#`, /\*pow=(on|off)#/i, tags);
                return match[1] ? match[1].toLowerCase() === 'on' : this.state.power.value;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                this.state.busy.update(true);
                const match = yield this.socket.send(`\r*pow=${power ? 'on' : 'off'}#`, /\*pow=(on|off)#/i, tags);
                this.framework.suspend(4000); // device is unresponsive while changing power
                this.busyTimeout.set(() => this.state.busy.update(false), 8000);
                return match[1] ? match[1].toLowerCase() === 'on' : this.state.power.value;
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\r*sour=?#`, /\*sour=(.+)#/i, tags);
                return match[1] ? match[1] : this.state.videoInput.value;
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                this.state.busy.update(true);
                const match = yield this.socket.send(`\r*sour=${code}#`, /\*sour=(.+)#/i, tags);
                this.framework.suspend(2000);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return match[1] ? match[1] : this.state.videoInput.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\r*vol=?#`, /\*vol=(.+)#|illegal/i, tags);
                return match[1] ? parseInt(match[1], 10) : this.state.volume.value;
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\r*vol=${volume}#`, /\*vol=(.+)#|illegal/i, tags);
                return match[1] ? parseInt(match[1], 10) : this.state.volume.value;
            }),
            range: { max: 100, min: 0, round: 1 },
            powerOffRestrictions: ['get', 'set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\r*mute=?#`, /\*mute=(on|off)#|illegal/i, tags);
                return match[1] ? match[1].toLowerCase() === 'on' : this.state.volumeMute.value;
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\r*mute=${mute ? 'on' : 'off'}#`, /\*mute=(on|off)#|illegal/i, tags);
                return match[1] ? match[1].toLowerCase() === 'on' : this.state.volumeMute.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            { intervalMs: 3000, controls: ['power', 'videoInput', 'volume', 'volumeMute'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, [
                {
                    errorCode: 'verifyFailed',
                    send: `\r*pow=?#`,
                    next: /\*pow=(.+)#/i,
                },
            ], credentials);
        });
    }
}
// static properties
BenQProjector.driverType = 'socketDriver';
BenQProjector.key = '-LwEnhXVHiKWie-oNXt9';
BenQProjector.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r'],
    },
    sendTerminator: '\r',
};
BenQProjector.socketOptions = [
    Object.assign(Object.assign({}, BenQProjector.baseSocketOptions), { port: 8000 }),
    Object.assign(Object.assign({}, BenQProjector.baseSocketOptions), { port: 4999 }),
];
